/**
 * PipedriveAPIV1Lib
 *
 * This file was automatically generated by APIMATIC v2.0 ( https://apimatic.io ).
 */

'use strict';

const FieldType4Enum = {

    /**
     * TODO: Write general description for this element
     */
    VARCHAR: 'varchar',

    /**
     * TODO: Write general description for this element
     */
    VARCHAR_AUTO: 'varchar_auto',

    /**
     * TODO: Write general description for this element
     */
    TEXT: 'text',

    /**
     * TODO: Write general description for this element
     */
    MDOUBLE: 'double',

    /**
     * TODO: Write general description for this element
     */
    MONETARY: 'monetary',

    /**
     * TODO: Write general description for this element
     */
    DATE: 'date',

    /**
     * TODO: Write general description for this element
     */
    SET: 'set',

    /**
     * TODO: Write general description for this element
     */
    ENUM: 'enum',

    /**
     * TODO: Write general description for this element
     */
    USER: 'user',

    /**
     * TODO: Write general description for this element
     */
    ORG: 'org',

    /**
     * TODO: Write general description for this element
     */
    PEOPLE: 'people',

    /**
     * TODO: Write general description for this element
     */
    PHONE: 'phone',

    /**
     * TODO: Write general description for this element
     */
    TIME: 'time',

    /**
     * TODO: Write general description for this element
     */
    TIMERANGE: 'timerange',

    /**
     * TODO: Write general description for this element
     */
    DATERANGE: 'daterange',

};

module.exports = FieldType4Enum;
